// AdminLayout.js
import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import Navbar2 from "../Header/Navbar2";
import Footer from "../Pages/Home/Footer";
import Breadcrumb from "./AdminBreadcrumb";

// Icons
import { IoWalletOutline } from "react-icons/io5";
import { PiTreeStructure } from "react-icons/pi";
import { RiAdvertisementLine } from "react-icons/ri";
import { MdManageAccounts } from "react-icons/md";

const AdminLayout = () => {
    const location = useLocation();
    // const isActive = (path) => location.pathname === path;
    const isActive = (path) => {
        return location.pathname === path || location.pathname.startsWith(path);
    };
    return (
        <>
            <div className="container-fluid bg-white nav-bar">
                <div className="container d-sm-none d-md-none d-lg-block">
                    <div className="horizontal-divider-black mb-1px"></div>
                </div>
                <div className="container d-sm-none d-md-none d-lg-block">
                    <div className="horizontal-divider-black"></div>
                </div>
                <div className="dashboard-nav">
                    <div className="container px-0">
                        <aside className="sidebar">
                            <nav className="d-sm-none d-md-flex">
                                <ul className="nav">
                                    <li className={`nav-item ${isActive("/admin/admin-dashboard") ? "highlighed-navitem" : ""}`}>
                                        <Link
                                            to="/admin/admin-dashboard"
                                            className={`nav-link text-dark ${isActive("/admin/admin-dashboard") ? "highlighed-navitem" : ""}`}
                                        >
                                            <i class="bi bi-house-door f-20 me-2 "></i>
                                            <span className="f-16">Dashboard</span>
                                        </Link>
                                    </li>
                                    <li
                                        className={`nav-item dropdown ${
                                            isActive("/admin/magazine-management") ||
                                            isActive("/admin/rss-management") ||
                                            isActive("/admin/article-management") ||
                                            isActive("/admin/category-management") ||
                                            isActive("/admin/comments-management") ||
                                            isActive("/admin/homepage-settings") ||
                                            isActive("/admin/highlight-settings")
                                                ? "highlighed-navitem"
                                                : ""
                                        }`}
                                    >
                                        <button className="nav-link text-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="bi bi-pencil-square f-20 me-2"></i>
                                            <span className="f-16">Content</span>
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <Link
                                                    to="/admin/magazine-management"
                                                    className={`dropdown-item ${
                                                        isActive("/admin/magazine-management") ||
                                                        isActive("/admin/add-magazine") ||
                                                        isActive("/admin/edit-magazine")
                                                            ? "highlighed-navitem"
                                                            : ""
                                                    }`}
                                                >
                                                    Magazine Management
                                                </Link>
                                            </li>

                                            <li>
                                                <Link
                                                    to="/admin/rss-management"
                                                    className={`dropdown-item ${
                                                        isActive("/admin/rss-management") || isActive("/admin/add-rsspost") || isActive("/admin/edit-rsspost")
                                                            ? "highlighed-navitem"
                                                            : ""
                                                    }`}
                                                >
                                                    Feed Article Management
                                                </Link>
                                            </li>

                                            <li>
                                                <Link
                                                    to="/admin/article-management"
                                                    className={`dropdown-item ${
                                                        isActive("/admin/article-management") || isActive("/admin/add-post") || isActive("/admin/edit-post")
                                                            ? "highlighed-navitem"
                                                            : ""
                                                    }`}
                                                >
                                                    Article Management
                                                </Link>
                                            </li>

                                            <li>
                                                <Link
                                                    to="/admin/category-management"
                                                    className={`dropdown-item ${isActive("/admin/category-management") ? "highlighed-navitem" : ""}`}
                                                >
                                                    Category Management
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/admin/sub-category-management"
                                                    className={`dropdown-item ${isActive("/admin/sub-category-management") ? "highlighed-navitem" : ""}`}
                                                >
                                                    Sub - Category Management
                                                </Link>
                                            </li>
                                            {/* <li>
                                                <Link
                                                    to="/admin/comments-management"
                                                    className={`dropdown-item ${isActive("/admin/comments-management") ? "highlighed-navitem" : ""}`}
                                                >
                                                    Comments Management
                                                </Link>
                                            </li> */}
                                            <li>
                                                <Link
                                                    to="/admin/homepage-settings"
                                                    className={`dropdown-item ${
                                                        isActive("/admin/homepage-settings") || isActive("/admin/edit-articlesettings")
                                                            ? "highlighed-navitem"
                                                            : ""
                                                    }`}
                                                >
                                                    Home Page Left & Right Setting
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/admin/highlight-settings"
                                                    className={`dropdown-item ${
                                                        isActive("/admin/highlight-settings") ||
                                                        isActive("/admin/add-highlight") ||
                                                        isActive("/admin/edit-highlight")
                                                            ? "highlighed-navitem"
                                                            : ""
                                                    }`}
                                                >
                                                    Today Highlight and Hot&Trending Setting
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li
                                        className={`nav-item dropdown ${
                                            isActive("/admin/user-management") ||
                                            isActive("/admin/ad-management") ||
                                            isActive("/admin/notification-management") ||
                                            isActive("/admin/subscription")
                                                ? "highlighed-navitem"
                                                : ""
                                        }`}
                                    >
                                        <button className="nav-link text-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="bi bi-person-fill-gear f-18 me-2"></i>
                                            <span className="f-16">Management</span>
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <Link
                                                    to="/admin/user-management"
                                                    className={`dropdown-item ${
                                                        isActive("/admin/user-management") || isActive("/admin/user/adduser") || isActive("/admin/user/edit")
                                                            ? "highlighed-navitem"
                                                            : ""
                                                    }`}
                                                >
                                                    User Management
                                                </Link>
                                            </li>

                                            {/* <li>
                                                    <Link
                                                    to="/admin/role-management"
                                                    className="dropdown-item"
                                                    >
                                                    Role Management
                                                    </Link>
                                                </li> */}
                                            <li>
                                                <Link
                                                    to="/admin/ad-management"
                                                    className={`dropdown-item ${isActive("/admin/ad-management") ? "highlighed-navitem" : ""}`}
                                                >
                                                    Ads Management
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/admin/notification-management"
                                                    className={`dropdown-item ${isActive("/admin/notification-management") ? "highlighed-navitem" : ""}`}
                                                >
                                                    Notification Management
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/admin/subscription"
                                                    className={`dropdown-item ${isActive("/admin/subscription") ? "highlighed-navitem" : ""}`}
                                                >
                                                    Subscription Management
                                                </Link>
                                            </li>
                                            {/* <li>
                                                    <Link
                                                    to="/admin/admin-reports"
                                                    className="dropdown-item"
                                                    >
                                                    Reports
                                                    </Link>
                                                </li> */}
                                        </ul>
                                    </li>

                                    <li className={`nav-item d-flex align-items-center ${isActive("/admin/genealogy-tree") ? "highlighed-navitem" : ""}`}>
                                        <Link to="/admin/genealogy-tree" className="nav-link text-dark text-end">
                                            <PiTreeStructure className="f-18 me-2" />
                                            <span className="f-16">Genealogy Tree</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <button
                                            className={`nav-link text-dark dropdown-toggle ${
                                                isActive("/admin/admin-ewallet") || isActive("/admin/admin-payout") ? "highlighed-navitem" : ""
                                            }`}
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <IoWalletOutline className="f-20 me-2" />
                                            <span className="f-16">Finance</span>
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <Link
                                                    to="/admin/admin-ewallet"
                                                    className={`dropdown-item ${isActive("/admin/admin-ewallet") ? "highlighed-navitem" : ""}`}
                                                >
                                                    E-wallet
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/admin/admin-payout"
                                                    className={`dropdown-item ${isActive("/admin/admin-payout") ? "highlighed-navitem" : ""}`}
                                                >
                                                    Payout
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className={`nav-item ${isActive("/admin/settings") ? "highlighed-navitem" : ""}`}>
                                        <Link to="/admin/settings" className="nav-link text-dark">
                                            <i class="bi bi-gear f-18 me-2"></i>
                                            <span className="f-16">Settings</span>
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                            <nav className="d-sm-flex d-md-none d-lg-none ">
                                <ul className="nav ">
                                    {/* <li className="nav-item">
                                        <Link to="/admin/admin-dashboard" className="nav-link text-dark">
                                            <i class="bi bi-house-door f-20 me-2"></i>
                                            <span className="f-16"></span>
                                        </Link>
                                    </li> */}
                                    <li className="nav-item dropdown">
                                        <button className="nav-link text-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="bi bi-pencil-square f-20 me-2"></i>
                                            <span className="f-16"></span>
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <Link to="/admin/magazine-management" className="dropdown-item">
                                                    Magazine Management
                                                </Link>
                                            </li>

                                            <li>
                                                <Link to="/admin/rss-management" className="dropdown-item">
                                                    Feed Article Management
                                                </Link>
                                            </li>

                                            <li>
                                                <Link to="/admin/article-management" className="dropdown-item">
                                                    Article Management
                                                </Link>
                                            </li>

                                            <li>
                                                <Link to="/admin/category-management" className="dropdown-item">
                                                    Category Management
                                                </Link>
                                            </li>
                                            {/* <li>
                                                <Link to="/admin/comments-management" className="dropdown-item">
                                                    Comments Management
                                                </Link>
                                            </li> */}
                                            <li>
                                                <Link to="/admin/homepage-settings" className="dropdown-item">
                                                    Home Page Left & Right Setting
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/admin/highlight-settings" className="dropdown-item">
                                                    Today Highlight and Hot&Trending Setting
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <button className="nav-link text-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="bi bi-person-fill-gear f-18 me-2"></i>
                                            <span className="f-16"></span>
                                        </button>
                                        <ul className="dropdown-menu" style={{ transform: "translate3D(-7px, 45px, 0px)" }}>
                                            <li>
                                                <Link to="/admin/user-management" className="dropdown-item">
                                                    User Management
                                                </Link>
                                            </li>

                                            {/* <li>
                        <Link
                          to="/admin/role-management"
                          className="dropdown-item"
                        >
                          Role Management
                        </Link>
                      </li> */}
                                            <li>
                                                <Link to="/admin/ad-management" className="dropdown-item">
                                                    Ads Management
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/admin/notification-management" className="dropdown-item">
                                                    Notification Management
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/admin/subscription" className="dropdown-item">
                                                    Subscription Management
                                                </Link>
                                            </li>
                                            {/* <li>
                                                <Link to="/admin/admin-reports" className="dropdown-item">
                                                    Reports
                                                </Link>
                                            </li> */}
                                        </ul>
                                    </li>
                                    {/* <li className="nav-item">
                                        <Link to="/admin/settings" className="nav-link text-dark">
                                            <i class="bi bi-gear f-18 me-2"></i>
                                            <span className="f-16"></span>
                                        </Link>
                                    </li> */}
                                    <li className="nav-item">
                                        <Link to="/admin/genealogy-tree" className="nav-link text-dark">
                                            <PiTreeStructure className="f-20 me-2" />
                                            <span className="f-16"></span>
                                        </Link>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <button className="nav-link text-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                            <IoWalletOutline className="f-20 me-2" />
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <Link to="/admin/admin-ewallet" className="dropdown-item">
                                                    E-wallet
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/admin/admin-payout" className="dropdown-item">
                                                    Payout
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="nav-item ">
                                        <Link to="/admin/settings" className="nav-link text-dark">
                                            <i class="bi bi-gear f-18 me-2"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                        </aside>
                    </div>
                </div>
            </div>

            <div className="light-bg">
                <div className="container">
                    <main className="content-container">
                        <Breadcrumb />
                        <Outlet /> {/* Renders the current route's component */}
                    </main>
                </div>
            </div>
            <style jsx>
                {`
                    .highlighed-navitem {
                        font-weight: 550;
                    }
                `}
            </style>
        </>
    );
};

export default AdminLayout;
